import { Module, GetterTree, ActionTree, MutationTree } from "vuex";
import http from "@/http";
import _ from "lodash";

const state: ServiceOrderState = {
  activeServiceOrder: null,
  newBulkServiceOrder: {
    business_oid: "",
    po_number: "",
    order_details: [],
    payment_details: [],
  },
};

const getters: GetterTree<ServiceOrderState, RootState> = {
  totalOrderDetailsAmount: (state) => (gstRate) => {
    return _.sumBy(
      state.newBulkServiceOrder.order_details,
      (item) => parseFloat((item.unit_price * item.quantity * (1 + gstRate)).toFixed(2)) | 0 // to get the whole number part of a floating-point number
    );
  },
  totalPaymentDetailsAmount: (state) => (gstRate) => {
    return _.sumBy(
      state.newBulkServiceOrder.payment_details,
      (item) => parseFloat((item.amount * (1 + gstRate)).toFixed(2)) | 0 // to get the whole number part of a floating-point number
    );
  },
};

const actions: ActionTree<ServiceOrderState, RootState> = {
  create({ commit }, payload) {
    return http.v1.so
      .create(payload)
      .then((response) => {
        if (response.data.data.service_payment) {
          commit(
            "ServicePayment/SET_ACTIVE_SERVICE_PAYMENT",
            response.data.data.service_payment,
            { root: true }
          );
        }
        if (response.data.data.service_order) {
          commit("SET_ACTIVE_SERVICE_ORDER", response.data.data.service_order);
        }
        return response.data.data.invoice_status;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  createBulkOrder({ commit }, payload) {
    return http.v1.so
      .createBulkOrder(payload)
      .then((response) => {
        if (response.data.data.service_payment) {
          commit(
            "ServicePayment/SET_ACTIVE_SERVICE_PAYMENT",
            response.data.data.service_payment,
            { root: true }
          );
        }
        commit("SET_ACTIVE_SERVICE_ORDER", response.data.data);
        return response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  fetch({ commit }, oid) {
    return http.v1.so
      .fetch(oid, {
        params: {
          expand: ["service_items", "service_payment.children", "business"],
        },
      })
      .then((response) => {
        if (response.data.data) {
          commit("SET_ACTIVE_SERVICE_ORDER", response.data.data);
          commit(
            "ServicePayment/SET_ACTIVE_SERVICE_PAYMENT",
            response.data.data.service_payment,
            { root: true }
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  fetchList(context, options) {
    return http.v1.so.fetchList(options).then(({ data }) => {
      const payload = data;
      const items = payload.data.data;
      return {
        items,
        total: payload.data.total,
      };
    });
  },
};

const mutations: MutationTree<ServiceOrderState> = {
  SET_ACTIVE_SERVICE_ORDER(state, activeServiceOrder) {
    state.activeServiceOrder = activeServiceOrder;
  },
  SET_NEW_BULK_SERVICE_ORDER(state, payload) {
    state.newBulkServiceOrder = payload;
  },
  CLEAR_STATE(state) {
    state.activeServiceOrder = null;
    state.newBulkServiceOrder = {
      business_oid: "",
      po_number: "",
      order_details: [],
      payment_details: [],
    };
  },
};

const serviceOrder: Module<ServiceOrderState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default serviceOrder;
